module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/expandable-rows/expandable-rows.component.css
// module id = ./src/app/examples/expandable-rows/expandable-rows.component.css
// module chunks = main